// src/components/Header/NavigationHeader.tsx
import React from "react";
// import { useTranslation } from "react-i18next";
import { Container } from "../Container/Container";
import { NavigationHeaderDesktop } from "./NavigationHeaderDesktop";
import { NavigationHeaderMobile } from "./NavigationHeaderMobile";
import { ButtonLanguageSelector } from "../Button/ButtonLanguageSelector";
import { useNavigation } from "../../hooks/useNavigation";

const setShowFooter = () => {
  // Logique pour afficher ou masquer le footer
  // console.log("Footer visibility:", show);
};

export const NavigationHeader: React.FC = () => {
  const { isOpen, setIsOpen } = useNavigation(setShowFooter);
  return (
    <nav className="bg-transparent z-50 pt-2">
      <Container className="flex items-center justify-between">
        <NavigationHeaderDesktop />

        <NavigationHeaderMobile isOpen={isOpen} setIsOpen={setIsOpen} />

        <div className="absolute right-20">
          <ButtonLanguageSelector />
        </div>
      </Container>
    </nav>
  );
};
